import { ErrorHandler, Injectable } from '@angular/core';
import { HttpService } from '../services/http-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PosthogService } from '../services/posthog.service';

@Injectable()
export class AppGlobalErrorhandler implements ErrorHandler {
  constructor(
    public httpService: HttpService,
    private deviceService: DeviceDetectorService,
    private posthog: PosthogService
  ) {}

  async handleError(error: Error) {
    // PostHog: Track application errors with full context
    this.posthog.captureEvent('app_error', {
      error_message: error.message,
      error_stack: error.stack,
      error_name: error.name,
      user_id: this.httpService.userId,
      device_type: this.deviceService.deviceType,
      device: this.deviceService.device,
      browser: this.deviceService.browser,
      browser_version: this.deviceService.browser_version,
      os: this.deviceService.os,
      orientation: this.deviceService.orientation,
      page_url: typeof window !== 'undefined' ? window.location.href : 'unknown',
      page_path: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    });

    throw error;
  }
}
